import { pathOr, toLower } from 'ramda';
import getUrlParamsToLower from './getUrlParamsToLower';
/**
 * Get URL parameter
 * @param {String} key
 * @return {String}
 */
const getUrlParam = (key) => pathOr('', [toLower(key)])(getUrlParamsToLower());
export default getUrlParam;
//# sourceMappingURL=getUrlParam.js.map